// @ts-nocheck
import React, { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import { t } from "i18next";
import genRequest from "includes/request";
import "./Targets.css";
import TagLabel from "components/Tags/Label/TagLabel";
import noAccent from "includes/no_accents";
import useAccount from "classes/Accounts/hooks/useAccount";

const AlertTargetsCell = React.memo(({ item }) => {
	return (
		<InfosFetcher
			queryKey={["posts", item.postId, "alerts"]}
			queryFn={() => genRequest("posts/" + item.postId + "/alerts")}
			treat={(linkeds) => {
				return t("Commons.TARGETS", {
					count: linkeds.length,
				}).toLowerCase();
			}}
		/>
	);
});
AlertTargetsCell.displayName = "AlertTargetsCell";

const TargetsCell = React.memo(({ item }) => {
	const { account } = useAccount();
	const { postId: PostId, siteId: SiteId, isTargetPost: IsTargetPost } = item;
	const [LtSites, setLtSites] = useState([]);
	const [LtGroups, setLtGroups] = useState([]);
	// Popper
	const [TM, setTM] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [referenceElement, setReferenceElement] = useState(null);
	const [SitesState, setSitesState] = useState({
		fetching: true,
		fetchingLt: true,
	});

	useEffect(() => {
		let isMounted = true;
		getDatas().then((datas) => {
			if (!isMounted) return;
			setLtSites(datas.post_sites);
			setLtGroups(datas.post_groups);
			setSitesState({
				fetching: false,
				fetchingLt: false,
			});
			setGroupsState({
				fetching: false,
				fetchingLt: false,
			});
		});
		return () => {
			isMounted = false;
			resetTm();
			setLtSites([]);
			setLtGroups([]);
			setSitesState({
				fetching: true,
				fetchingLt: true,
			});
		};
	}, []);

	const [GroupsState, setGroupsState] = useState({
		fetching: true,
		fetchingLt: true,
	});

	const siteFormatText = (count, max) => {
		return t("Targets.published", {
			context: count === max ? "sites_all" : "sites",
			count,
		});
	};

	const groupFormatText = (count, max) => {
		return t("Targets.published", {
			context: count === max ? "groups_all" : "groups",
			count,
		});
	};

	const handleShowPopper = () => {
		resetTm(
			setTimeout(() => {
				setIsOpen(true);
			}, 200)
		);
	};

	const resetTm = (new_tm) => {
		clearTimeout(TM);
		setTM(new_tm ? new_tm : false);
	};

	const closePopper = () => {
		setIsOpen(false);
		resetTm();
	};

	const fetchSites = () =>
		genRequest("sites/company/" + account.companyId);

	const fetchPostSites = (sites_list) => {
		let req = genRequest("sites/post/" + PostId).then(
			(resp) => {
				let ret = [];
				if (resp?.length) {
					ret = resp
						.map((a) => {
							if (sites_list?.length) {
								let site = sites_list.find(
									(s_a) => s_a.id === a.id
								);
								if (site !== -1) return site;
							}
							return false;
						})
						.filter((a) => a);
				}
				return ret;
			},
			() => {
				setLtSites(false);
				return false;
			}
		);
		return req;
	};

	const fetchGroups = () =>
		genRequest("groups/company/" + account.companyId);

	const fetchDocGroups = () => {
		let req = genRequest("groups/post/" + PostId).then(
			(resp) => {
				let ret = resp?.length ? resp : [];
				return ret;
			},
			() => {
				setLtGroups(false);
				return false;
			}
		);
		return req;
	};

	const getDatas = async () => {
		let sites = await fetchSites();
		let groups = await fetchGroups();
		let post_sites = await fetchPostSites(sites);
		let post_groups = await fetchDocGroups();
		return {
			sites,
			groups,
			post_sites,
			post_groups,
		};
	};

	return item.postTypeId === 13 ? (
		<AlertTargetsCell item={item} />
	) : (
		<div ref={setReferenceElement}>
			<InfosFetcher
				queryFn={fetchSites}
				queryKey={["Sites", "SitesOfCompany", account.companyId]}
				options={{
					retry: 0,
					onSettled: () =>
						setSitesState({
							fetchingLt: !IsTargetPost,
							fetching: false,
						}),
				}}
				treat={(sites) => {
					return (
						<InfosFetcher
							queryFn={() => fetchPostSites(sites)}
							queryKey={["Sites", "AllSiteOfPost", PostId]}
							options={{
								retry: 0,
								enabled: !IsTargetPost,
								onSettled: () =>
									setSitesState({
										fetching: false,
										fetchingLt: false,
									}),
							}}
							treat={(resp) => {
								if (!resp?.length || IsTargetPost) return false;
								return (
									<div
										className="d-flex align-items-center"
										onMouseEnter={handleShowPopper}
										onMouseLeave={closePopper}
									>
										<div>
											{siteFormatText(
												resp?.length,
												sites.length
											)}
										</div>
										<TargetsPopper
											referenceElement={referenceElement}
											postId={PostId}
											type="sites"
											items={resp}
											isOpen={isOpen}
											closePopper={closePopper}
										/>
									</div>
								);
							}}
						/>
					);
				}}
			/>
			<InfosFetcher
				queryFn={fetchGroups}
				queryKey={["Groups", "OfCompany", account.companyId]}
				options={{
					retry: 0,
					onSettled: () =>
						setGroupsState({
							fetchingLt: IsTargetPost,
							fetching: false,
						}),
				}}
				treat={(groups) => {
					return (
						<InfosFetcher
							queryFn={fetchDocGroups}
							queryKey={["Groups", "FullGroupOfPost", PostId]}
							options={{
								retry: 0,
								onSettled: () =>
									setGroupsState({
										fetchingLt: false,
										fetching: false,
									}),
							}}
							treat={(resp) => {
								if (!resp?.length) return false;
								return (
									<div
										className="d-flex align-items-center"
										onMouseEnter={handleShowPopper}
										onMouseLeave={closePopper}
										ref={setReferenceElement}
									>
										<div>
											{groupFormatText(
												resp?.length,
												groups?.length
											)}
										</div>
										<TargetsPopper
											referenceElement={referenceElement}
											postId={PostId}
											type="groups"
											items={resp}
											isOpen={isOpen}
											closePopper={closePopper}
										/>
									</div>
								);
							}}
						/>
					);
				}}
			/>
			{!!GroupsState.fetching &&
				!GroupsState.fetchingLt &&
				!LtGroups?.length &&
				!SitesState.fetching &&
				!SitesState.fetchingLt &&
				!LtSites?.length && (
					<InfosFetcher
						queryFn={() => genRequest("sites/" + SiteId)}
						queryKey={["Sites", SiteId]}
						treat={(resp) => {
							if (IsTargetPost) return "Aucune cible";
							return (
								resp.siteName + (resp.address ? " - " + resp.address : "")
							);
						}}
					/>
				)}
		</div>
	);
});
TargetsCell.displayName = "TargetsCell";

function TargetsPopper(props) {
	const { type, isOpen } = props;
	const { items } = props;
	const [popperElement, setPopperElement] = useState(null);
	const { styles, attributes } = usePopper(
		props.referenceElement,
		popperElement,
		{
			placement: "right",
		}
	);

	const genDom = (data) => {
		if (type === "groups")
			return data
				.sort((a, b) => (a.groupName < b.groupName ? -1 : 1))
				.map((a) => (
					<TagLabel
						key={a.id}
						text={a.groupName}
						color={a.defaultHexaColor}
					/>
				));
		if (data && !data?.length) data = [data];
		let dom = data
			.sort((a, b) => {
				let a_name = noAccent(
					(
						a.siteName + (a.address ? " - " + a.address : "")
					).toLocaleLowerCase()
				);
				let b_name = noAccent(
					(
						b.siteName + (b.address ? " - " + b.address : "")
					).toLocaleLowerCase()
				);
				return a_name < b_name ? -1 : 1;
			})
			.map((a) => {
				let name = a.siteName + (a.address ? " - " + a.address : "");
				return <TagLabel key={a.id} text={name} />;
			});
		return dom;
	};

	return (
		<>
			{isOpen && (
				<div
					className="targets-popper"
					ref={setPopperElement}
					onMouseLeave={props.closePopper}
					style={styles.popper}
					{...attributes.popper}
				>
					<div className="popper d-flex flex-wrap flex-row gap-1">
						{genDom(items)}
					</div>
				</div>
			)}
		</>
	);
}

export default TargetsCell;
